"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SkeletonContainer = styled_components_1.default.div `
  width: ${props => ((props === null || props === void 0 ? void 0 : props.width) ? props.width : props.theme.spacing.xl1)}px;
  ${props => (props === null || props === void 0 ? void 0 : props.fullWidth) && 'width: 100%;'}
  ${props => (props === null || props === void 0 ? void 0 : props.marginTop) && `margin-top: ${props.marginTop}px;`}
  ${props => (props === null || props === void 0 ? void 0 : props.marginBottom) && `margin-bottom: ${props.marginBottom}px;`}
  height: ${props => ((props === null || props === void 0 ? void 0 : props.height) ? props.height : props.theme.constants.searchTab.paddingLeft)}px;
  border-radius: ${props => props.theme.spacing.s7}px;
  background: ${props => props.theme.palette.MEDIUM_GRAY_90};
  background-image: linear-gradient(
    to right,
    ${props => props.theme.palette.MEDIUM_GRAY_90} 0%,
    ${props => props.theme.palette.BLUE_5} 20%,
    ${props => props.theme.palette.MEDIUM_GRAY_90} 40%,
    ${props => props.theme.palette.MEDIUM_GRAY_90} 100%
  );
  background-repeat: no-repeat;
  background-size: ${props => props.theme.constants.blockHeight.xl1}px 104px;
  animation: ${props => props.theme.themeKeyframes.placeholderShimmer} 1s linear infinite forwards;
`;
exports.default = {
    SkeletonContainer: exports.SkeletonContainer
};
